type Platform = 'ios' | 'android' | 'other';

/**
 * Detects the current device platform from the user agent string.
 * Returns `'other'` during SSR or on non-mobile devices.
 */
export function getPlatform(): Platform {
  if (typeof navigator === 'undefined') return 'other';

  const ua = navigator.userAgent;

  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';

  return 'other';
}

/**
 * Builds a navigation URL for the given coordinates based on the device
 * platform. iOS opens Apple Maps; Android and others open Google Maps.
 */
export function getNavigationUrl(lat: number, lng: number): string {
  const platform = getPlatform();
  if (platform === 'ios') {
    return `https://maps.apple.com/?daddr=${lat},${lng}`;
  }
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
}
